module.exports = __webpack_public_path__ + "img/nopay.32486058.png";